export function LogoMark({ className = "w-8 h-8" }) {
  return (
    <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
      <path
        d="M45 75C30 75 20 63 20 48C20 35 30 25 43 25C54 25 61 32 61 43C61 58 42 66 35 70C30 73 25 75 20 75"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
      />
      <path d="M55 75L75 35" stroke="currentColor" strokeWidth="7" strokeLinecap="round" />
      <path
        d="M65 25C65 25 78 20 82 32C86 44 75 52 75 52C75 52 65 42 65 25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Logo({ variant = "a", onDark = false, accent }) {
  const isA = variant === "a";
  const markColor = isA ? accent || "text-lime" : "text-forest";
  return (
    <span
      className={`inline-flex items-center gap-2.5 ${isA ? "font-bodya" : "font-bodyb"}`}
      data-testid={`logo-${variant}`}
    >
      <LogoMark className={`${markColor} w-8 h-8 shrink-0`} />
      <span className="inline-flex flex-col leading-none">
        <span
          className={`leading-none ${
            isA
              ? "font-displaya font-bold uppercase tracking-[0.06em] text-[20px]"
              : "font-displayb font-light text-[22px]"
          } ${isA ? "text-cream" : onDark ? "text-cream" : "text-forest"}`}
        >
          Well<span className={isA ? "text-lime" : "italic text-clay"}>&</span>Truly
        </span>
        <span
          className={`mt-1 text-[10px] font-medium uppercase tracking-[0.3em] ${
            isA ? "text-cream/60" : onDark ? "text-cream/50" : "text-forest/55"
          }`}
        >
          by Akanksha
        </span>
      </span>
    </span>
  );
}
